var render, staticRenderFns
import script from "./PaymentsMixin.vue?vue&type=script&lang=js&"
export * from "./PaymentsMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c386f6a",
  null
  
)

export default component.exports